import styled from 'styled-components'
import { mildGray, softGray } from '../../../styles/variables.js'

const List = styled.div`
  margin: 5px;
`
const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${softGray};
  margin-bottom: 8px;
  border-radius: 4px;
`

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  & > form {
    margin-right: 10px;
  }

  .passwordInput input {
    text-security:disc;
    -webkit-text-security:disc;
    -mox-text-security:disc;
  }
`

const ItemFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const Locales = styled.div`
  margin-left: 10px;
  flex: 1 1;
`

const DeleteLink = styled.div`
  margin-right: 10px;
  margin-top: 34px;
  cursor: pointer;
  color: ${mildGray};
  transition: all .1s ease-in-out;
  flex: 0 0;
  max-height: 24px;
  font-size: 22px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`
const IconPlaceholder = styled.div`
  width: 24px;
`

export default {
  List,
  Item,
  ItemContent,
  ItemFooter,
  DeleteLink,
  Locales,
  IconPlaceholder,
}
